// extracted by mini-css-extract-plugin
module.exports = {"container":"AccountData_container__DQesY","wrapper":"AccountData_wrapper__94d2f","inputSpacer":"AccountData_inputSpacer__Ciw0V","divider":"AccountData_divider__rczmG"};